import _ from 'lodash';
import { isEmail, isMobilePhone } from 'validator';
import { format } from 'date-fns-tz';
import template from './equipmentNotifications.html';


export default {
  name: 'equipmentNotificationsComponent',
  template,
  controller: EquipmentNotificationsController,
  controllerAs: 'EquipmentNotificationsCtrl'
};

/* @ngInject */
function EquipmentNotificationsController(
  $scope,
  $interval,
  $state,
  $stateParams,
  $transitions,
  growl,
  EquipmentNotificationsService,
  EquipmentService,
  EquipmentInfoService,
  ModalService,
  dateFilter,
) {
  const vm = this;
  const equipmentListObj = {};
  let currentTimeInterval = null;
  const days = 7;
  const hoursInDay = 24;
  const HOURS_IN_WEEK = days * hoursInDay;
  const FIFTEEN_MINUTES = 1000 * 15 * 60; // in milliseconds
  const GROWL_TTL = 3000;
  const GROWL_THROTTLE = 7000;
  const PHONE_NUMBER_LENGTH = 10;
  let saveAllDisableWatcher;
  let lastSelectedTimezone;

  vm.equipment = [];
  vm.activeEquipment = null;
  vm.schedulerOptions = null;
  vm.selectTagTokens = 'SPACE|,|;|ENTER';
  vm.selectTagLabel = '(new)';
  vm.equipmentHasNoEvents = false;
  vm.tableCollapse = {};
  vm.escalationRange = [];

  vm.$onInit = init;
  vm.$onDestroy = handleControllerDestroy;
  vm.selectEquipment = selectEquipment;
  vm.saveEventSchedule = saveEventSchedule;
  vm.scheduleTabSelected = scheduleTabSelected;
  vm.takeItToTheNextLevel = takeItToTheNextLevel;
  vm.addToConfigured = addToConfigured;
  vm.standardizeTelNumberFormat = standardizeTelNumberFormat;
  vm.deleteLevel = _.pullAt;
  vm.deleteEvent = deleteEvent;
  vm.copyEvent = copyEvent;
  vm.saveAllPolicies = saveAllPolicies;
  vm.preventAndStop = preventAndStop;
  vm.checkSaveAllEnabled = checkSaveAllEnabled;
  vm.toggleEditMode = toggleEditMode;
  vm.tab = tab;
  vm.scheduleToolTip = 'Select the timezone where the equipment physically resides.';
  vm.tick = tick;
  vm.updateEventSchedule = updateEventSchedule;
  vm.onScheduleSelectionChange = onScheduleSelectionChange;
  // for tests
  vm._emailsValid = validateEmails;
  vm._phoneNumbersValid = validatePhones;
  vm._initializeEventSchedule = initializeEventSchedule;
  vm._getOffsetDayAndHour = getOffsetDayAndHour;

  const DAYS_OF_WEEK = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6
  };
  vm.timeZoneOptions = [{
    zone: 'Eastern',
    date: 'America/New_York'
  }, {
    zone: 'Central',
    date: 'America/Chicago'
  }, {
    zone: 'Mountain',
    date: 'America/Denver'
  }, {
    zone: 'Arizona',
    date: 'America/Phoenix'
  }, {
    zone: 'Pacific',
    date: 'America/Los_Angeles'
  }];
  const DAY_NAMES = _.keys(DAYS_OF_WEEK);

  function init() {
    // TODO: This is probably not ideal
    for (let i = 0; i <= 360; i++) {
      vm.escalationRange.push({
        minutes: `${i} minute${i === 1 ? '' : 's'}`,
        milliseconds: i * 1000 * 60
      });
    }
    if (saveAllDisableWatcher) {
      saveAllDisableWatcher();
    }

    $transitions.onSuccess(
      { to: 'admin.equipmentNotifications' },
      // ? Deselect any selected equipment when returning to main parent route
      () => vm.activeEquipment && selectEquipment()
    );

    return EquipmentNotificationsService.getEquipmentList()
      .then(({ asObj, asArray }) => {
        _.merge(equipmentListObj, asObj);
        vm.equipment = asArray.sort((a, b) => a.name.localeCompare(b.name));
      })
      .then(() => {
        $stateParams.id && selectEquipment($stateParams);
      });
  }

  function selectEquipment(eq = vm.activeEquipment) {
    // Deselecting
    if (!eq?.id) {
      vm.activeEquipment = undefined;
      $state.go('admin.equipmentNotifications');
      return false;
    }
    // Preserve current tab when selecting new equipment
    const [,, route = 'alerts'] = $state.current.name.split('.');
    tab(route, eq.id);

    vm.activeEquipment = eq;
    vm.fullEqSelected = vm.equipment.find(fullEq => fullEq.id === eq.id);
    return initScheduleModel();
  }


  async function initScheduleModel() {
    const { id, notificationConfig, schedule } = vm.activeEquipment;
    const equipment = notificationConfig && schedule ?
      equipmentListObj[id] :
      await EquipmentNotificationsService.getEquipmentNotifications(id);

    vm.schedulerOptions = null;
    vm.stopEquipmentLogsLoader = false;
    vm.disableInfiniteScroll = false;
    vm.notificationEvents = [];
    vm.unusedEvents = [];

    if (!equipment.schedule) {
      equipment.schedule = { enabled: false };
    }

    vm.timeZone = _.find(vm.timeZoneOptions, { date: equipment.schedule.timeZone }) ||
                    _.find(vm.timeZoneOptions, { date: EquipmentNotificationsService.getLocalTimeZone() }) ||
                    vm.timeZoneOptions[1];

    lastSelectedTimezone = vm.timeZone;

    vm.schedulerOptions = {
      selected: initializeEventSchedule(equipment.schedule),
      reset: true,
      onChange: (selected) => {
        vm.schedulerOptions.selected = selected;
      }
    };

    _.get(equipment, 'notificationConfig.eventsConfig').forEach((event) => {
      if (_.get(event, 'escalations.levels.length') > 0) {
        vm.notificationEvents.push(event);
      } else {
        vm.unusedEvents.push(event);
      }
    });
    vm.equipmentHasNoEvents = !_.get(equipment, ['notificationConfig', 'eventsConfig', 'length'], false);

    _.assign(equipmentListObj[id], equipment);
    vm.activeEquipment = equipmentListObj[id];
  }

  function initializeEventSchedule(schedule) {
    const selected = [];
    if (_.isObject(schedule.data)) {
      const offset = format(new Date(), 'x', { timeZone: _.get(vm, 'timeZone.date', vm.timeZoneOptions[1].date) });
      const isOldVersion = _.get(schedule, 'version') !== 2;
      _.forEach(schedule.data, (hoursOfDay, day) => {
        _.forEach(hoursOfDay, (isDisabled, hour) => {
          if (isDisabled) {
            hour = hour.replace('_', '.');
            if (isOldVersion) {
              // handle old version in utc without timezone
              const { offsetDay, offsetHour } = vm._getOffsetDayAndHour(day, hour, offset);
              selected.push(`${DAY_NAMES[offsetDay]}-${offsetHour}`);
              if (_.isInteger(Number(hour))) { // convert old version to display in new version
                selected.push(`${DAY_NAMES[offsetDay]}-${offsetHour}.5`);
              }
            } else {
              // handle new version with timezone in timezone time
              selected.push(`${DAY_NAMES[day]}-${hour}`);
            }
          }
        });
      });
    }
    return selected;
  }

  function updateEventSchedule() {
    const now = new Date();
    const oldZoneOffset = Number(format(now, 'x', { timeZone: lastSelectedTimezone.date }));
    const newZoneOffset = Number(format(now, 'x', { timeZone: vm.timeZone.date }));
    const diffOffset = newZoneOffset - oldZoneOffset;

    if (diffOffset !== 0) {
      vm.schedulerOptions.selected = _.map(vm.schedulerOptions.selected, (dayAndHour) => {
        const [day, hour] = dayAndHour.split('-');
        const offsetDayAndHour = vm._getOffsetDayAndHour(DAYS_OF_WEEK[day], hour, diffOffset);
        return `${DAY_NAMES[offsetDayAndHour.offsetDay]}-${offsetDayAndHour.offsetHour}`;
      });

      vm.reloadScheduler();
      tick();
      growl.success('Schedule Times Shifted');
    }

    lastSelectedTimezone = vm.timeZone;

  }

  async function saveEventSchedule() {
    if (!_.get(vm, 'timeZone.date')) {
      growl.error('Must select time zone before saving', { title: 'Error Saving Event Schedule: ' });
      return;
    }
    const newDisableSchedule = {};
    _.forEach(vm.schedulerOptions.selected, (dayAndHour) => {
      const [day, hour] = dayAndHour.split('-');
      _.setWith(newDisableSchedule, [DAYS_OF_WEEK[day], hour.replace('.', '_')], true, Object);
    });

    vm.activeEquipment.schedule.data = newDisableSchedule;

    const growlMessage = growl.info('Saving Event Schedule...', { disableCloseButton: true });
    const res = await EquipmentService.editEquipment(vm.activeEquipment.id, {
      dontUpdateRcu: true,
      updates: {
        schedule: {
          data: vm.activeEquipment.schedule.data,
          enabled: vm.activeEquipment.schedule.enabled,
          timeZone: vm.timeZone.date,
          version: 2
        }
      }
    }).catch(resp => resp);
    growlMessage.destroy();
    if (_.has(res, 'error')) {
      growl.error(res.error, { title: 'Error Saving Event Schedule: ' });
      return;
    }
    growl.success('Event Schedule Saved');
    if (_.get(res, ['data', 'length'])) {
      EquipmentInfoService.updateEquipment(res.data[0]);
    }
  }

  function getOffsetDayAndHour(day, hour, offset) {
    const offsetHourInWeek =
        ((Number(day) * hoursInDay) + Number(hour) + Number(offset) + HOURS_IN_WEEK) % HOURS_IN_WEEK;
    return {
      offsetHourInWeek,
      offsetDay: Math.floor(offsetHourInWeek / hoursInDay),
      offsetHour: offsetHourInWeek % hoursInDay
    };
  }

  function scheduleTabSelected(isSelected) {
    return isSelected ? startCurrentTimeInterval() : killCurrentTimeInterval();
  }

  function tick() {
    if (_.get(vm, 'timeZone.date')) {
      vm.current = dateFilter(new Date().toLocaleString('en-US', {
        timeZone: vm.timeZone.date
      }), 'MMM d, y HH:mm:ss a');
    }
  }

  function startCurrentTimeInterval() {
    tick();
    if (!currentTimeInterval) {
      const tickTime = 1000;
      currentTimeInterval = $interval(tick, tickTime);
    }
  }

  function killCurrentTimeInterval() {
    if (currentTimeInterval) {
      $interval.cancel(currentTimeInterval);
      currentTimeInterval = null;
    }
  }

  function handleControllerDestroy() {
    // add cleanup code here
    killCurrentTimeInterval();
  }

  function onScheduleSelectionChange(update, eventsConfig) {
    $scope.$apply(() => {
      eventsConfig.schedule = update;
    });
  }

  function takeItToTheNextLevel(config) {
    _.defaults(config, { escalations: { levels: [], requireAcknowledgement: false } });
    const { escalations, escalations: { levels } } = config;
    levels.push({
      customMessage: `Level ${levels.length + 1}`, // TODO: This is bloat. Rely on defaults instead
      escalationTime: FIFTEEN_MINUTES,
      emails: [],
      phoneNumbers: []
    });
    escalations.requireAcknowledgement = levels.length > 1;
  }

  function addToConfigured(event) {
    if (event) {
      const removed = _.remove(vm.unusedEvents, ev => ev.title === event.title)[0];
      removed.isOpen = true;
      removed.enabled = true;
      removed.enableEdit = true;
      takeItToTheNextLevel(removed);
      vm.notificationEvents.push(removed);
    }
  }

  function standardizeTelNumberFormat(phoneNumber) {
    // Strip out all hyphens if any from phoneNumber
    phoneNumber = phoneNumber.replaceAll('-', '');
    // If they added a preceding 1 or other strip it out. i,e 1-888-888-8888 -> 888-888-8888
    phoneNumber = _.slice(phoneNumber, -PHONE_NUMBER_LENGTH).join('');
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }

  async function copyEvent(notificationConfig) {
    try {
      const updatedEq = await ModalService.openAlertPolicy(notificationConfig, vm.activeEquipment.org);
      _.merge(equipmentListObj, _.keyBy(updatedEq, 'id'));
      initScheduleModel();
    } catch {
      // user dismissed modal
    }
  }

  vm.disabledReminder = _.throttle((enableEdit) => {
    if (!enableEdit) {
      growl.info('Enable Edit Mode', { ttl: GROWL_TTL });
    }
  }, GROWL_THROTTLE, { trailing: false });

  async function deleteEvent({ name, title }) {

    await ModalService.confirmationModal({
      modalTitle: `Are sure you want to delete ${title}?`,
      optionalWarning: 'This action will delete alerts associated with this event.',
    });

    const activeEqEvent = _.find(vm.activeEquipment.notificationConfig.eventsConfig, { name });
    activeEqEvent.escalations = {
      levels: [],
      requireAcknowledgement: false,
    };
    activeEqEvent.enabled = false;

    const growlMessage = growl.info('Deleting notification...', { disableCloseButton: true });
    let success = true;
    try {
      const policy = EquipmentNotificationsService.updateNotePolicy([vm.activeEquipment]);
      await EquipmentService.editNotificationConfigs(policy);
    } catch (error) {
      console.error(error);
      growl.error('Please try again', { title: 'Error Saving Notifications' });
      success = false;
    }
    initScheduleModel();
    growlMessage.destroy();
    success && growl.success('Notifications Saved');
  }

  /**
   * @param {object} level
   * @param {Array<string>} [level.emails]
   * @returns {boolean}
   */
  function validateEmails(level) {
    return _.every(level.emails, email => isEmail(email));
  }

  /**
   * @param {object} level
   * @param {Array<string>} [level.phoneNumbers]
   * @returns {boolean}
   */
  function validatePhones(level) {
    return _.every(level.phoneNumbers, pn => isMobilePhone(pn, 'en-US'));
  }

  function errorsForLevel(level, index, title) {
    const levelId = level.customMessage || `Level ${index + 1}`;
    const empty = _.isEmpty([...level.emails, ...level.phoneNumbers]);
    level.emailsHaveError = empty;
    level.numbersHaveError = empty;
    if (empty) {
      return [`-${levelId} of ${title} must contain at least one contact\n`];
    }
    const errors = [];
    if (!validateEmails(level)) {
      level.emailsHaveError = true;
      errors.push(`-${levelId} of ${title} contains invalid emails\n`);
    }
    if (!validatePhones(level)) {
      level.numbersHaveError = true;
      errors.push(`-${levelId} of ${title} contains invalid phone numbers\n`);
    }
    return errors;
  }

  async function saveAllPolicies() {
    const errors = _.reduce(vm.notificationEvents, (acc, { escalations, title }) => {
      const eventErrs = _.reduce(escalations.levels, (lvlErrs, level, index) =>
        [...lvlErrs, ...errorsForLevel(level, index, title)], []);
      return [...acc, ...eventErrs];
    }, []);

    if (!_.isEmpty(errors)) {
      return growl.error(`\n ${errors.join('\n')}`, { title: 'Contact info validation error.' });
    }
    const noteConfigs = EquipmentNotificationsService.updateNotePolicy([vm.activeEquipment]); // remove extra params
    _.forEach(vm.notificationEvents, config => _.set(config, 'enableEdit', false));

    const growlMessage = growl.info('Saving notification...', { disableCloseButton: true });
    const res = await EquipmentService.editNotificationConfigs(noteConfigs);
    growlMessage.destroy();
    if (_.has(res.error)) {
      return growl.error(res.error, { title: 'Error Saving Notifications:' });
    }
    growl.success('Notifications Saved');
    EquipmentInfoService.updateEquipment(vm.activeEquipment);
    return null;
  }

  function preventAndStop(ev) {
    ev.preventDefault();
    ev.stopPropagation();
  }

  function checkSaveAllEnabled() {
    return _.some(_.get(vm, 'activeEquipment.notificationConfig.eventsConfig'), 'enableEdit');
  }

  const backups = {
    /* eslint-disable angular/no-private-call */
    store: {},
    save(config) {
      this.store[config.$$hashKey] = _.cloneDeep(config);
    },
    restore(config) {
      const backup = _.get(this.store, config.$$hashKey);
      if (!backup) {
        throw new Error('No backup available for', config);
      }
      _.assign(config, backup);
      this.clear(config);
    },
    clear(config) {
      this.store[config.$$hashKey] = undefined;
    }
    /* eslint-enable angular/no-private-call */
  };

  async function toggleEditMode(eventsConfig) {
    const { enableEdit: discarding } = eventsConfig;
    if (discarding) {
      backups.restore(eventsConfig);
      eventsConfig.enableEdit = false;
    } else {
      backups.save(eventsConfig);
      eventsConfig.isOpen = true;
      eventsConfig.enableEdit = true;
    }
  }

  function tab(to, of = $stateParams.id) {
    $state.go(`admin.equipmentNotifications.${to}`, { id: of });
    vm.activeTab = ['alerts', 'schedule', 'logs'].indexOf(to);
  }

}
